(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["s1-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  window._s1 = window._s1 || {};
  if (window._s1.cardEnhancementsBound) return;
  window._s1.cardEnhancementsBound = true;

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var control = event.target.closest('.color-swatch, [data-style-btn]');
    if (!control) return;
    var card = control.closest('.catalog_product');
    if (!card) return;

    if (control.matches('.color-swatch')) {
      var wrapper = control.closest('[data-swatch-wrapper]');
      if (!wrapper) return;
      card.querySelectorAll('[data-swatch-wrapper]').forEach(function (swatch) {
        swatch.classList.toggle('is-selected', swatch === wrapper);
      });
      return;
    }

    var newSrc = control.dataset.imgSrc;
    var qbId = control.dataset.quickBuyId;
    var price = control.dataset.price;
    var productUrl = control.dataset.productUrl;
    var callout = control.dataset.callout;

    var img = card.querySelector('[data-main-image]');
    if (img && newSrc) {
      if (typeof window._s1.swapImageSrcset === 'function') {
        window._s1.swapImageSrcset(img, newSrc);
      } else {
        img.src = newSrc;
        img.srcset = newSrc;
      }
    }

    var mainLink = card.querySelector('[data-main-link]');
    if (mainLink) mainLink.setAttribute('href', productUrl);
    var shopAllBtn = card.querySelector('.catalog_product_cta a');
    if (shopAllBtn) shopAllBtn.setAttribute('href', productUrl);
    var atcBtn = card.querySelector('[id^="catalog_product_cta_atc"]');
    if (atcBtn) atcBtn.setAttribute('aria-controls', qbId);
    var priceEl = card.querySelector('.catalog_product_price');
    if (priceEl && price) priceEl.textContent = price;
    var calloutEl = card.querySelector('[data-callout-display]');
    if (calloutEl && callout) calloutEl.textContent = callout;

    card.querySelectorAll('[data-style-btn]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn === control);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
